/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import {
  AppointmentDayCounts,
  AppointmentFilterOptions,
  AppointmentPage,
  AppointmentRow,
  AppointmentStats,
  BookingLink,
  ClinicHealth,
  ClinicSettings,
  ClinicShell,
  ErrorEvent,
  ErrorEventPage,
  ErrorSummary,
  IncidentPage,
  PfLink,
  RefreshFromPfResponse,
  SourceList,
  SourceRow,
  TempPasswordResult,
  UserList,
  UserRow,
} from './model'
import type {
  AddSourceRequest,
  AddUserRequest,
  ApiError,
  ChangeRoleRequest,
  EndImpersonationRequest,
  GetAppointmentDayCountsParams,
  GetAppointmentStatsParams,
  GetBookingLinkParams,
  GetClinicHealthParams,
  ListAppointmentsParams,
  ListClinicIncidentsParams,
  ListErrorsParams,
  ListSourcesParams,
  PutSettingsRequest,
} from './model'

import { apiFetch } from '../../fetcher.ts'
import type { ErrorType, BodyType } from '../../fetcher.ts'
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getListAppointmentsUrl = (clinicId: string, params?: ListAppointmentsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/clinic/clinics/${clinicId}/appointments?${stringifiedParams}`
    : `/v1/clinic/clinics/${clinicId}/appointments`
}

/**
 * @summary Filtered, sorted, paged appointments, with day totals in the appointment view (C-01)
 */
export const listAppointments = async (
  clinicId: string,
  params?: ListAppointmentsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<AppointmentPage> => {
  return apiFetch<AppointmentPage>(getListAppointmentsUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: AppointmentPage,
  })
}

export const getListAppointmentsQueryKey = (clinicId: string, params?: ListAppointmentsParams) => {
  return [`/v1/clinic/clinics/${clinicId}/appointments`, ...(params ? [params] : [])] as const
}

export const getListAppointmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAppointments>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListAppointmentsQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAppointments>>> = ({ signal }) =>
    listAppointments(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ListAppointmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAppointments>>>
export type ListAppointmentsQueryError = ErrorType<ApiError>

export function useListAppointments<TData = Awaited<ReturnType<typeof listAppointments>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params: undefined | ListAppointmentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAppointments>>,
          TError,
          Awaited<ReturnType<typeof listAppointments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAppointments<TData = Awaited<ReturnType<typeof listAppointments>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAppointments>>,
          TError,
          Awaited<ReturnType<typeof listAppointments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAppointments<TData = Awaited<ReturnType<typeof listAppointments>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Filtered, sorted, paged appointments, with day totals in the appointment view (C-01)
 */

export function useListAppointments<TData = Awaited<ReturnType<typeof listAppointments>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListAppointmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAppointments>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAppointmentsQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAppointmentDayCountsUrl = (clinicId: string, params: GetAppointmentDayCountsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/clinic/clinics/${clinicId}/appointments/day-counts?${stringifiedParams}`
    : `/v1/clinic/clinics/${clinicId}/appointments/day-counts`
}

/**
 * @summary Appointment counts per visit date and location (C-10 holiday "already booked" tag)
 */
export const getAppointmentDayCounts = async (
  clinicId: string,
  params: GetAppointmentDayCountsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<AppointmentDayCounts> => {
  return apiFetch<AppointmentDayCounts>(getGetAppointmentDayCountsUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: AppointmentDayCounts,
  })
}

export const getGetAppointmentDayCountsQueryKey = (clinicId: string, params?: GetAppointmentDayCountsParams) => {
  return [`/v1/clinic/clinics/${clinicId}/appointments/day-counts`, ...(params ? [params] : [])] as const
}

export const getGetAppointmentDayCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentDayCounts>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: GetAppointmentDayCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDayCounts>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentDayCountsQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentDayCounts>>> = ({ signal }) =>
    getAppointmentDayCounts(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDayCounts>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetAppointmentDayCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointmentDayCounts>>>
export type GetAppointmentDayCountsQueryError = ErrorType<ApiError>

export function useGetAppointmentDayCounts<
  TData = Awaited<ReturnType<typeof getAppointmentDayCounts>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: GetAppointmentDayCountsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDayCounts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentDayCounts>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentDayCounts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointmentDayCounts<
  TData = Awaited<ReturnType<typeof getAppointmentDayCounts>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: GetAppointmentDayCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDayCounts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentDayCounts>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentDayCounts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointmentDayCounts<
  TData = Awaited<ReturnType<typeof getAppointmentDayCounts>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: GetAppointmentDayCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDayCounts>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Appointment counts per visit date and location (C-10 holiday "already booked" tag)
 */

export function useGetAppointmentDayCounts<
  TData = Awaited<ReturnType<typeof getAppointmentDayCounts>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: GetAppointmentDayCountsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentDayCounts>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentDayCountsQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAppointmentFilterOptionsUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/appointments/filter-options`
}

/**
 * @summary Visit types, locations, providers and sources for the C-01 filters
 */
export const getAppointmentFilterOptions = async (
  clinicId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<AppointmentFilterOptions> => {
  return apiFetch<AppointmentFilterOptions>(getGetAppointmentFilterOptionsUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: AppointmentFilterOptions,
  })
}

export const getGetAppointmentFilterOptionsQueryKey = (clinicId: string) => {
  return [`/v1/clinic/clinics/${clinicId}/appointments/filter-options`] as const
}

export const getGetAppointmentFilterOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentFilterOptions>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentFilterOptions>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentFilterOptionsQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentFilterOptions>>> = ({ signal }) =>
    getAppointmentFilterOptions(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAppointmentFilterOptions>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetAppointmentFilterOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppointmentFilterOptions>>
>
export type GetAppointmentFilterOptionsQueryError = ErrorType<ApiError>

export function useGetAppointmentFilterOptions<
  TData = Awaited<ReturnType<typeof getAppointmentFilterOptions>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentFilterOptions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentFilterOptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointmentFilterOptions<
  TData = Awaited<ReturnType<typeof getAppointmentFilterOptions>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentFilterOptions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentFilterOptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointmentFilterOptions<
  TData = Awaited<ReturnType<typeof getAppointmentFilterOptions>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentFilterOptions>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Visit types, locations, providers and sources for the C-01 filters
 */

export function useGetAppointmentFilterOptions<
  TData = Awaited<ReturnType<typeof getAppointmentFilterOptions>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentFilterOptions>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentFilterOptionsQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAppointmentStatsUrl = (clinicId: string, params?: GetAppointmentStatsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/clinic/clinics/${clinicId}/appointments/stats?${stringifiedParams}`
    : `/v1/clinic/clinics/${clinicId}/appointments/stats`
}

/**
 * @summary Total, sources and trend buckets for a period, in the clinic time zone (C-01 stats card)
 */
export const getAppointmentStats = async (
  clinicId: string,
  params?: GetAppointmentStatsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<AppointmentStats> => {
  return apiFetch<AppointmentStats>(getGetAppointmentStatsUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: AppointmentStats,
  })
}

export const getGetAppointmentStatsQueryKey = (clinicId: string, params?: GetAppointmentStatsParams) => {
  return [`/v1/clinic/clinics/${clinicId}/appointments/stats`, ...(params ? [params] : [])] as const
}

export const getGetAppointmentStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentStats>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: GetAppointmentStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentStats>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentStatsQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentStats>>> = ({ signal }) =>
    getAppointmentStats(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAppointmentStats>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetAppointmentStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointmentStats>>>
export type GetAppointmentStatsQueryError = ErrorType<ApiError>

export function useGetAppointmentStats<
  TData = Awaited<ReturnType<typeof getAppointmentStats>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: undefined | GetAppointmentStatsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentStats>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointmentStats<
  TData = Awaited<ReturnType<typeof getAppointmentStats>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: GetAppointmentStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentStats>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointmentStats<
  TData = Awaited<ReturnType<typeof getAppointmentStats>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: GetAppointmentStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentStats>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Total, sources and trend buckets for a period, in the clinic time zone (C-01 stats card)
 */

export function useGetAppointmentStats<
  TData = Awaited<ReturnType<typeof getAppointmentStats>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: GetAppointmentStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentStats>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentStatsQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAppointmentUrl = (clinicId: string, appointmentId: string) => {
  return `/v1/clinic/clinics/${clinicId}/appointments/${appointmentId}`
}

/**
 * @summary One appointment (C-01a)
 */
export const getAppointment = async (
  clinicId: string,
  appointmentId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<AppointmentRow> => {
  return apiFetch<AppointmentRow>(getGetAppointmentUrl(clinicId, appointmentId), {
    ...options,
    method: 'GET',

    schema: AppointmentRow,
  })
}

export const getGetAppointmentQueryKey = (clinicId: string, appointmentId: string) => {
  return [`/v1/clinic/clinics/${clinicId}/appointments/${appointmentId}`] as const
}

export const getGetAppointmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointment>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentQueryKey(clinicId, appointmentId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointment>>> = ({ signal }) =>
    getAppointment(clinicId, appointmentId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined && appointmentId !== null && appointmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetAppointmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointment>>>
export type GetAppointmentQueryError = ErrorType<ApiError>

export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  appointmentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointment>>,
          TError,
          Awaited<ReturnType<typeof getAppointment>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointment>>,
          TError,
          Awaited<ReturnType<typeof getAppointment>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One appointment (C-01a)
 */

export function useGetAppointment<TData = Awaited<ReturnType<typeof getAppointment>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointment>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentQueryOptions(clinicId, appointmentId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAppointmentPfLinkUrl = (clinicId: string, appointmentId: string) => {
  return `/v1/clinic/clinics/${clinicId}/appointments/${appointmentId}/pf-link`
}

/**
 * @summary The patient's Practice Fusion Appointments-timeline URL, looked up on demand (C-01 / C-01a)
 */
export const getAppointmentPfLink = async (
  clinicId: string,
  appointmentId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<PfLink> => {
  return apiFetch<PfLink>(getGetAppointmentPfLinkUrl(clinicId, appointmentId), {
    ...options,
    method: 'GET',

    schema: PfLink,
  })
}

export const getGetAppointmentPfLinkQueryKey = (clinicId: string, appointmentId: string) => {
  return [`/v1/clinic/clinics/${clinicId}/appointments/${appointmentId}/pf-link`] as const
}

export const getGetAppointmentPfLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppointmentPfLink>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentPfLink>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAppointmentPfLinkQueryKey(clinicId, appointmentId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppointmentPfLink>>> = ({ signal }) =>
    getAppointmentPfLink(clinicId, appointmentId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined && appointmentId !== null && appointmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAppointmentPfLink>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetAppointmentPfLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getAppointmentPfLink>>>
export type GetAppointmentPfLinkQueryError = ErrorType<ApiError>

export function useGetAppointmentPfLink<
  TData = Awaited<ReturnType<typeof getAppointmentPfLink>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  appointmentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentPfLink>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentPfLink>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentPfLink>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointmentPfLink<
  TData = Awaited<ReturnType<typeof getAppointmentPfLink>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentPfLink>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppointmentPfLink>>,
          TError,
          Awaited<ReturnType<typeof getAppointmentPfLink>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppointmentPfLink<
  TData = Awaited<ReturnType<typeof getAppointmentPfLink>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentPfLink>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The patient's Practice Fusion Appointments-timeline URL, looked up on demand (C-01 / C-01a)
 */

export function useGetAppointmentPfLink<
  TData = Awaited<ReturnType<typeof getAppointmentPfLink>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppointmentPfLink>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAppointmentPfLinkQueryOptions(clinicId, appointmentId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetBookingLinkUrl = (clinicId: string, params?: GetBookingLinkParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/clinic/clinics/${clinicId}/booking-link?${stringifiedParams}`
    : `/v1/clinic/clinics/${clinicId}/booking-link`
}

/**
 * @summary The booking link and embed code, with an optional signed preset (C-02)
 */
export const getBookingLink = async (
  clinicId: string,
  params?: GetBookingLinkParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<BookingLink> => {
  return apiFetch<BookingLink>(getGetBookingLinkUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: BookingLink,
  })
}

export const getGetBookingLinkQueryKey = (clinicId: string, params?: GetBookingLinkParams) => {
  return [`/v1/clinic/clinics/${clinicId}/booking-link`, ...(params ? [params] : [])] as const
}

export const getGetBookingLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookingLink>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: GetBookingLinkParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingLink>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBookingLinkQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingLink>>> = ({ signal }) =>
    getBookingLink(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getBookingLink>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetBookingLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingLink>>>
export type GetBookingLinkQueryError = ErrorType<ApiError>

export function useGetBookingLink<TData = Awaited<ReturnType<typeof getBookingLink>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params: undefined | GetBookingLinkParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingLink>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingLink>>,
          TError,
          Awaited<ReturnType<typeof getBookingLink>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingLink<TData = Awaited<ReturnType<typeof getBookingLink>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: GetBookingLinkParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingLink>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingLink>>,
          TError,
          Awaited<ReturnType<typeof getBookingLink>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingLink<TData = Awaited<ReturnType<typeof getBookingLink>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: GetBookingLinkParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingLink>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The booking link and embed code, with an optional signed preset (C-02)
 */

export function useGetBookingLink<TData = Awaited<ReturnType<typeof getBookingLink>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: GetBookingLinkParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingLink>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBookingLinkQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getListErrorsUrl = (clinicId: string, params?: ListErrorsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/clinic/clinics/${clinicId}/errors?${stringifiedParams}`
    : `/v1/clinic/clinics/${clinicId}/errors`
}

/**
 * @summary Filtered, paged error events, newest first (C-03)
 */
export const listErrors = async (
  clinicId: string,
  params?: ListErrorsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ErrorEventPage> => {
  return apiFetch<ErrorEventPage>(getListErrorsUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: ErrorEventPage,
  })
}

export const getListErrorsQueryKey = (clinicId: string, params?: ListErrorsParams) => {
  return [`/v1/clinic/clinics/${clinicId}/errors`, ...(params ? [params] : [])] as const
}

export const getListErrorsQueryOptions = <TData = Awaited<ReturnType<typeof listErrors>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListErrorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listErrors>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListErrorsQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listErrors>>> = ({ signal }) =>
    listErrors(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listErrors>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ListErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof listErrors>>>
export type ListErrorsQueryError = ErrorType<ApiError>

export function useListErrors<TData = Awaited<ReturnType<typeof listErrors>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params: undefined | ListErrorsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listErrors>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listErrors>>,
          TError,
          Awaited<ReturnType<typeof listErrors>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListErrors<TData = Awaited<ReturnType<typeof listErrors>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListErrorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listErrors>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listErrors>>,
          TError,
          Awaited<ReturnType<typeof listErrors>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListErrors<TData = Awaited<ReturnType<typeof listErrors>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListErrorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listErrors>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Filtered, paged error events, newest first (C-03)
 */

export function useListErrors<TData = Awaited<ReturnType<typeof listErrors>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListErrorsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listErrors>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListErrorsQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetErrorSummaryUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/errors/summary`
}

/**
 * @summary Errors in the last 24 h / 7 days (filters ignored) and counts per code (C-03 counters and type filter)
 */
export const getErrorSummary = async (
  clinicId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ErrorSummary> => {
  return apiFetch<ErrorSummary>(getGetErrorSummaryUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: ErrorSummary,
  })
}

export const getGetErrorSummaryQueryKey = (clinicId: string) => {
  return [`/v1/clinic/clinics/${clinicId}/errors/summary`] as const
}

export const getGetErrorSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getErrorSummary>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorSummary>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetErrorSummaryQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getErrorSummary>>> = ({ signal }) =>
    getErrorSummary(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getErrorSummary>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetErrorSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getErrorSummary>>>
export type GetErrorSummaryQueryError = ErrorType<ApiError>

export function useGetErrorSummary<TData = Awaited<ReturnType<typeof getErrorSummary>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorSummary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getErrorSummary>>,
          TError,
          Awaited<ReturnType<typeof getErrorSummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetErrorSummary<TData = Awaited<ReturnType<typeof getErrorSummary>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorSummary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getErrorSummary>>,
          TError,
          Awaited<ReturnType<typeof getErrorSummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetErrorSummary<TData = Awaited<ReturnType<typeof getErrorSummary>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorSummary>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Errors in the last 24 h / 7 days (filters ignored) and counts per code (C-03 counters and type filter)
 */

export function useGetErrorSummary<TData = Awaited<ReturnType<typeof getErrorSummary>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrorSummary>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetErrorSummaryQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetErrorUrl = (clinicId: string, errorId: string) => {
  return `/v1/clinic/clinics/${clinicId}/errors/${errorId}`
}

/**
 * @summary One error event (C-03a)
 */
export const getError = async (
  clinicId: string,
  errorId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ErrorEvent> => {
  return apiFetch<ErrorEvent>(getGetErrorUrl(clinicId, errorId), {
    ...options,
    method: 'GET',

    schema: ErrorEvent,
  })
}

export const getGetErrorQueryKey = (clinicId: string, errorId: string) => {
  return [`/v1/clinic/clinics/${clinicId}/errors/${errorId}`] as const
}

export const getGetErrorQueryOptions = <TData = Awaited<ReturnType<typeof getError>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  errorId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getError>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetErrorQueryKey(clinicId, errorId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getError>>> = ({ signal }) =>
    getError(clinicId, errorId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined && errorId !== null && errorId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getError>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetErrorQueryResult = NonNullable<Awaited<ReturnType<typeof getError>>>
export type GetErrorQueryError = ErrorType<ApiError>

export function useGetError<TData = Awaited<ReturnType<typeof getError>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  errorId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getError>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getError>>, TError, Awaited<ReturnType<typeof getError>>>,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetError<TData = Awaited<ReturnType<typeof getError>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  errorId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getError>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getError>>, TError, Awaited<ReturnType<typeof getError>>>,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetError<TData = Awaited<ReturnType<typeof getError>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  errorId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getError>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One error event (C-03a)
 */

export function useGetError<TData = Awaited<ReturnType<typeof getError>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  errorId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getError>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetErrorQueryOptions(clinicId, errorId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetClinicHealthUrl = (clinicId: string, params?: GetClinicHealthParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/clinic/clinics/${clinicId}/health?${stringifiedParams}`
    : `/v1/clinic/clinics/${clinicId}/health`
}

/**
 * @summary Current PF state, daily bars and uptime per component (C-12, PF status card)
 */
export const getClinicHealth = async (
  clinicId: string,
  params?: GetClinicHealthParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ClinicHealth> => {
  return apiFetch<ClinicHealth>(getGetClinicHealthUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: ClinicHealth,
  })
}

export const getGetClinicHealthQueryKey = (clinicId: string, params?: GetClinicHealthParams) => {
  return [`/v1/clinic/clinics/${clinicId}/health`, ...(params ? [params] : [])] as const
}

export const getGetClinicHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getClinicHealth>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: GetClinicHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetClinicHealthQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClinicHealth>>> = ({ signal }) =>
    getClinicHealth(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getClinicHealth>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetClinicHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getClinicHealth>>>
export type GetClinicHealthQueryError = ErrorType<ApiError>

export function useGetClinicHealth<TData = Awaited<ReturnType<typeof getClinicHealth>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params: undefined | GetClinicHealthParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicHealth>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicHealth>>,
          TError,
          Awaited<ReturnType<typeof getClinicHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClinicHealth<TData = Awaited<ReturnType<typeof getClinicHealth>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: GetClinicHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicHealth>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClinicHealth>>,
          TError,
          Awaited<ReturnType<typeof getClinicHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClinicHealth<TData = Awaited<ReturnType<typeof getClinicHealth>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: GetClinicHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Current PF state, daily bars and uptime per component (C-12, PF status card)
 */

export function useGetClinicHealth<TData = Awaited<ReturnType<typeof getClinicHealth>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: GetClinicHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClinicHealth>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClinicHealthQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getListClinicIncidentsUrl = (clinicId: string, params?: ListClinicIncidentsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/clinic/clinics/${clinicId}/health/incidents?${stringifiedParams}`
    : `/v1/clinic/clinics/${clinicId}/health/incidents`
}

/**
 * @summary Incidents, ongoing first then newest first, 20 per page (C-12 incident history)
 */
export const listClinicIncidents = async (
  clinicId: string,
  params?: ListClinicIncidentsParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<IncidentPage> => {
  return apiFetch<IncidentPage>(getListClinicIncidentsUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: IncidentPage,
  })
}

export const getListClinicIncidentsQueryKey = (clinicId: string, params?: ListClinicIncidentsParams) => {
  return [`/v1/clinic/clinics/${clinicId}/health/incidents`, ...(params ? [params] : [])] as const
}

export const getListClinicIncidentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listClinicIncidents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListClinicIncidentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicIncidents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListClinicIncidentsQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listClinicIncidents>>> = ({ signal }) =>
    listClinicIncidents(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listClinicIncidents>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ListClinicIncidentsQueryResult = NonNullable<Awaited<ReturnType<typeof listClinicIncidents>>>
export type ListClinicIncidentsQueryError = ErrorType<ApiError>

export function useListClinicIncidents<
  TData = Awaited<ReturnType<typeof listClinicIncidents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params: undefined | ListClinicIncidentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicIncidents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinicIncidents>>,
          TError,
          Awaited<ReturnType<typeof listClinicIncidents>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClinicIncidents<
  TData = Awaited<ReturnType<typeof listClinicIncidents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListClinicIncidentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicIncidents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClinicIncidents>>,
          TError,
          Awaited<ReturnType<typeof listClinicIncidents>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClinicIncidents<
  TData = Awaited<ReturnType<typeof listClinicIncidents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListClinicIncidentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicIncidents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Incidents, ongoing first then newest first, 20 per page (C-12 incident history)
 */

export function useListClinicIncidents<
  TData = Awaited<ReturnType<typeof listClinicIncidents>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListClinicIncidentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listClinicIncidents>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListClinicIncidentsQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/settings`
}

/**
 * @summary Saved settings, catalog and profile: the base of the Settings draft (C-04…C-10)
 */
export const getSettings = async (
  clinicId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ClinicSettings> => {
  return apiFetch<ClinicSettings>(getGetSettingsUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: ClinicSettings,
  })
}

export const getGetSettingsQueryKey = (clinicId: string) => {
  return [`/v1/clinic/clinics/${clinicId}/settings`] as const
}

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) =>
    getSettings(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = ErrorType<ApiError>

export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettings>>,
          TError,
          Awaited<ReturnType<typeof getSettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettings>>,
          TError,
          Awaited<ReturnType<typeof getSettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Saved settings, catalog and profile: the base of the Settings draft (C-04…C-10)
 */

export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/settings`
}

/**
 * @summary Save the Settings draft (clinic-owned fields only) with a version check (C-04 Save)
 */
export const putSettings = async (
  clinicId: string,
  putSettingsRequest?: PutSettingsRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<ClinicSettings> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<ClinicSettings>(getPutSettingsUrl(clinicId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putSettingsRequest),
    schema: ClinicSettings,
  })
}

export const getPutSettingsMutationKey = () => ['putSettings'] as const

export const getPutSettingsMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof putSettings>>, TError, PutSettingsMutationVariables, TContext>
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof putSettings>>, TError, PutSettingsMutationVariables, TContext> => {
  const mutationKey = getPutSettingsMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSettings>>, PutSettingsMutationVariables> = (
    props,
  ) => {
    const { clinicId, data } = props ?? {}

    return putSettings(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putSettings>>>
export type PutSettingsMutationBody = BodyType<PutSettingsRequest> | undefined
export type PutSettingsMutationError = ErrorType<ApiError>
export type PutSettingsMutationVariables = { clinicId: string; data?: BodyType<PutSettingsRequest> }

/**
 * @summary Save the Settings draft (clinic-owned fields only) with a version check (C-04 Save)
 */
export const usePutSettings = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettings>>,
      TError,
      PutSettingsMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof putSettings>>, TError, PutSettingsMutationVariables, TContext> => {
  return useMutation(getPutSettingsMutationOptions(options), queryClient)
}

export const getRefreshFromPfUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/settings/refresh-from-pf`
}

/**
 * @summary Re-read the PF catalog; update PF-owned fields only; return a summary (C-04 Refresh from PF)
 */
export const refreshFromPf = async (
  clinicId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<RefreshFromPfResponse> => {
  return apiFetch<RefreshFromPfResponse>(getRefreshFromPfUrl(clinicId), {
    ...options,
    method: 'POST',

    schema: RefreshFromPfResponse,
  })
}

export const getRefreshFromPfMutationKey = () => ['refreshFromPf'] as const

export const getRefreshFromPfMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshFromPf>>,
    TError,
    RefreshFromPfMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof refreshFromPf>>, TError, RefreshFromPfMutationVariables, TContext> => {
  const mutationKey = getRefreshFromPfMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshFromPf>>, RefreshFromPfMutationVariables> = (
    props,
  ) => {
    const { clinicId } = props ?? {}

    return refreshFromPf(clinicId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RefreshFromPfMutationResult = NonNullable<Awaited<ReturnType<typeof refreshFromPf>>>

export type RefreshFromPfMutationError = ErrorType<ApiError>
export type RefreshFromPfMutationVariables = { clinicId: string }

/**
 * @summary Re-read the PF catalog; update PF-owned fields only; return a summary (C-04 Refresh from PF)
 */
export const useRefreshFromPf = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshFromPf>>,
      TError,
      RefreshFromPfMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof refreshFromPf>>, TError, RefreshFromPfMutationVariables, TContext> => {
  return useMutation(getRefreshFromPfMutationOptions(options), queryClient)
}

export const getGetShellUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/shell`
}

/**
 * @summary Clinic header, PF status, errors in the last 24 h, link and embed URLs (C-00 shell, C-02)
 */
export const getShell = async (clinicId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ClinicShell> => {
  return apiFetch<ClinicShell>(getGetShellUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: ClinicShell,
  })
}

export const getGetShellQueryKey = (clinicId: string) => {
  return [`/v1/clinic/clinics/${clinicId}/shell`] as const
}

export const getGetShellQueryOptions = <TData = Awaited<ReturnType<typeof getShell>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getShell>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetShellQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShell>>> = ({ signal }) =>
    getShell(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getShell>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetShellQueryResult = NonNullable<Awaited<ReturnType<typeof getShell>>>
export type GetShellQueryError = ErrorType<ApiError>

export function useGetShell<TData = Awaited<ReturnType<typeof getShell>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getShell>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getShell>>, TError, Awaited<ReturnType<typeof getShell>>>,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShell<TData = Awaited<ReturnType<typeof getShell>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getShell>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getShell>>, TError, Awaited<ReturnType<typeof getShell>>>,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShell<TData = Awaited<ReturnType<typeof getShell>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getShell>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Clinic header, PF status, errors in the last 24 h, link and embed URLs (C-00 shell, C-02)
 */

export function useGetShell<TData = Awaited<ReturnType<typeof getShell>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getShell>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetShellQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getListSourcesUrl = (clinicId: string, params?: ListSourcesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/clinic/clinics/${clinicId}/sources?${stringifiedParams}`
    : `/v1/clinic/clinics/${clinicId}/sources`
}

/**
 * @summary Saved, unlisted and Unknown sources with booking counts (C-11, C-02 picker)
 */
export const listSources = async (
  clinicId: string,
  params?: ListSourcesParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<SourceList> => {
  return apiFetch<SourceList>(getListSourcesUrl(clinicId, params), {
    ...options,
    method: 'GET',

    schema: SourceList,
  })
}

export const getListSourcesQueryKey = (clinicId: string, params?: ListSourcesParams) => {
  return [`/v1/clinic/clinics/${clinicId}/sources`, ...(params ? [params] : [])] as const
}

export const getListSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSources>>,
  TError = ErrorType<ApiError>,
>(
  clinicId: string,
  params?: ListSourcesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSources>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListSourcesQueryKey(clinicId, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSources>>> = ({ signal }) =>
    listSources(clinicId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listSources>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ListSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listSources>>>
export type ListSourcesQueryError = ErrorType<ApiError>

export function useListSources<TData = Awaited<ReturnType<typeof listSources>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params: undefined | ListSourcesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSources>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSources>>,
          TError,
          Awaited<ReturnType<typeof listSources>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSources<TData = Awaited<ReturnType<typeof listSources>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListSourcesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSources>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSources>>,
          TError,
          Awaited<ReturnType<typeof listSources>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSources<TData = Awaited<ReturnType<typeof listSources>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListSourcesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSources>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Saved, unlisted and Unknown sources with booking counts (C-11, C-02 picker)
 */

export function useListSources<TData = Awaited<ReturnType<typeof listSources>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  params?: ListSourcesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSources>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSourcesQueryOptions(clinicId, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getAddSourceUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/sources`
}

/**
 * @summary Save a source slug, immediately (C-11 Add source / Add to list)
 */
export const addSource = async (
  clinicId: string,
  addSourceRequest?: AddSourceRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<SourceRow> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<SourceRow>(getAddSourceUrl(clinicId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addSourceRequest),
    schema: SourceRow,
  })
}

export const getAddSourceMutationKey = () => ['addSource'] as const

export const getAddSourceMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof addSource>>, TError, AddSourceMutationVariables, TContext>
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof addSource>>, TError, AddSourceMutationVariables, TContext> => {
  const mutationKey = getAddSourceMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof addSource>>, AddSourceMutationVariables> = (props) => {
    const { clinicId, data } = props ?? {}

    return addSource(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AddSourceMutationResult = NonNullable<Awaited<ReturnType<typeof addSource>>>
export type AddSourceMutationBody = BodyType<AddSourceRequest> | undefined
export type AddSourceMutationError = ErrorType<ApiError>
export type AddSourceMutationVariables = { clinicId: string; data?: BodyType<AddSourceRequest> }

/**
 * @summary Save a source slug, immediately (C-11 Add source / Add to list)
 */
export const useAddSource = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof addSource>>, TError, AddSourceMutationVariables, TContext>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof addSource>>, TError, AddSourceMutationVariables, TContext> => {
  return useMutation(getAddSourceMutationOptions(options), queryClient)
}

export const getRemoveSourceUrl = (clinicId: string, slug: string) => {
  return `/v1/clinic/clinics/${clinicId}/sources/${slug}`
}

/**
 * @summary Remove a saved source slug, immediately (C-11 Remove)
 */
export const removeSource = async (
  clinicId: string,
  slug: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<void> => {
  return apiFetch<void>(getRemoveSourceUrl(clinicId, slug), {
    ...options,
    method: 'DELETE',
  })
}

export const getRemoveSourceMutationKey = () => ['removeSource'] as const

export const getRemoveSourceMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeSource>>,
    TError,
    RemoveSourceMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof removeSource>>, TError, RemoveSourceMutationVariables, TContext> => {
  const mutationKey = getRemoveSourceMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeSource>>, RemoveSourceMutationVariables> = (
    props,
  ) => {
    const { clinicId, slug } = props ?? {}

    return removeSource(clinicId, slug, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RemoveSourceMutationResult = NonNullable<Awaited<ReturnType<typeof removeSource>>>

export type RemoveSourceMutationError = ErrorType<ApiError>
export type RemoveSourceMutationVariables = { clinicId: string; slug: string }

/**
 * @summary Remove a saved source slug, immediately (C-11 Remove)
 */
export const useRemoveSource = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeSource>>,
      TError,
      RemoveSourceMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof removeSource>>, TError, RemoveSourceMutationVariables, TContext> => {
  return useMutation(getRemoveSourceMutationOptions(options), queryClient)
}

export const getListUsersUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/users`
}

/**
 * @summary The clinic's users, by name (C-13)
 */
export const listUsers = async (clinicId: string, options?: Parameters<typeof apiFetch>[1]): Promise<UserList> => {
  return apiFetch<UserList>(getListUsersUrl(clinicId), {
    ...options,
    method: 'GET',

    schema: UserList,
  })
}

export const getListUsersQueryKey = (clinicId: string) => {
  return [`/v1/clinic/clinics/${clinicId}/users`] as const
}

export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey(clinicId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) =>
    listUsers(clinicId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicId !== null && clinicId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<ApiError>

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof listUsers>>, TError, Awaited<ReturnType<typeof listUsers>>>,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The clinic's users, by name (C-13)
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<ApiError>>(
  clinicId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListUsersQueryOptions(clinicId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getAddUserUrl = (clinicId: string) => {
  return `/v1/clinic/clinics/${clinicId}/users`
}

/**
 * @summary Add a user; the temporary password is returned once (C-13a → C-13b)
 */
export const addUser = async (
  clinicId: string,
  addUserRequest?: AddUserRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<TempPasswordResult> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<TempPasswordResult>(getAddUserUrl(clinicId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addUserRequest),
    schema: TempPasswordResult,
  })
}

export const getAddUserMutationKey = () => ['addUser'] as const

export const getAddUserMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof addUser>>, TError, AddUserMutationVariables, TContext>
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof addUser>>, TError, AddUserMutationVariables, TContext> => {
  const mutationKey = getAddUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof addUser>>, AddUserMutationVariables> = (props) => {
    const { clinicId, data } = props ?? {}

    return addUser(clinicId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AddUserMutationResult = NonNullable<Awaited<ReturnType<typeof addUser>>>
export type AddUserMutationBody = BodyType<AddUserRequest> | undefined
export type AddUserMutationError = ErrorType<ApiError>
export type AddUserMutationVariables = { clinicId: string; data?: BodyType<AddUserRequest> }

/**
 * @summary Add a user; the temporary password is returned once (C-13a → C-13b)
 */
export const useAddUser = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof addUser>>, TError, AddUserMutationVariables, TContext>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof addUser>>, TError, AddUserMutationVariables, TContext> => {
  return useMutation(getAddUserMutationOptions(options), queryClient)
}

export const getRemoveUserUrl = (clinicId: string, userId: string) => {
  return `/v1/clinic/clinics/${clinicId}/users/${userId}`
}

/**
 * @summary Remove the membership and end the user's sessions (C-13 Remove)
 */
export const removeUser = async (
  clinicId: string,
  userId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<void> => {
  return apiFetch<void>(getRemoveUserUrl(clinicId, userId), {
    ...options,
    method: 'DELETE',
  })
}

export const getRemoveUserMutationKey = () => ['removeUser'] as const

export const getRemoveUserMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof removeUser>>, TError, RemoveUserMutationVariables, TContext>
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof removeUser>>, TError, RemoveUserMutationVariables, TContext> => {
  const mutationKey = getRemoveUserMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeUser>>, RemoveUserMutationVariables> = (props) => {
    const { clinicId, userId } = props ?? {}

    return removeUser(clinicId, userId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RemoveUserMutationResult = NonNullable<Awaited<ReturnType<typeof removeUser>>>

export type RemoveUserMutationError = ErrorType<ApiError>
export type RemoveUserMutationVariables = { clinicId: string; userId: string }

/**
 * @summary Remove the membership and end the user's sessions (C-13 Remove)
 */
export const useRemoveUser = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof removeUser>>, TError, RemoveUserMutationVariables, TContext>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof removeUser>>, TError, RemoveUserMutationVariables, TContext> => {
  return useMutation(getRemoveUserMutationOptions(options), queryClient)
}

export const getChangeUserRoleUrl = (clinicId: string, userId: string) => {
  return `/v1/clinic/clinics/${clinicId}/users/${userId}`
}

/**
 * @summary Change a user's role (C-13 Change role)
 */
export const changeUserRole = async (
  clinicId: string,
  userId: string,
  changeRoleRequest?: ChangeRoleRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<UserRow> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<UserRow>(getChangeUserRoleUrl(clinicId, userId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changeRoleRequest),
    schema: UserRow,
  })
}

export const getChangeUserRoleMutationKey = () => ['changeUserRole'] as const

export const getChangeUserRoleMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserRole>>,
    TError,
    ChangeUserRoleMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeUserRole>>,
  TError,
  ChangeUserRoleMutationVariables,
  TContext
> => {
  const mutationKey = getChangeUserRoleMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeUserRole>>, ChangeUserRoleMutationVariables> = (
    props,
  ) => {
    const { clinicId, userId, data } = props ?? {}

    return changeUserRole(clinicId, userId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ChangeUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof changeUserRole>>>
export type ChangeUserRoleMutationBody = BodyType<ChangeRoleRequest> | undefined
export type ChangeUserRoleMutationError = ErrorType<ApiError>
export type ChangeUserRoleMutationVariables = { clinicId: string; userId: string; data?: BodyType<ChangeRoleRequest> }

/**
 * @summary Change a user's role (C-13 Change role)
 */
export const useChangeUserRole = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeUserRole>>,
      TError,
      ChangeUserRoleMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof changeUserRole>>, TError, ChangeUserRoleMutationVariables, TContext> => {
  return useMutation(getChangeUserRoleMutationOptions(options), queryClient)
}

export const getResetUserPasswordUrl = (clinicId: string, userId: string) => {
  return `/v1/clinic/clinics/${clinicId}/users/${userId}/reset-password`
}

/**
 * @summary A new temporary password, shown once (C-13 Reset password → C-13b)
 */
export const resetUserPassword = async (
  clinicId: string,
  userId: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<TempPasswordResult> => {
  return apiFetch<TempPasswordResult>(getResetUserPasswordUrl(clinicId, userId), {
    ...options,
    method: 'POST',

    schema: TempPasswordResult,
  })
}

export const getResetUserPasswordMutationKey = () => ['resetUserPassword'] as const

export const getResetUserPasswordMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetUserPassword>>,
    TError,
    ResetUserPasswordMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetUserPassword>>,
  TError,
  ResetUserPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getResetUserPasswordMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetUserPassword>>,
    ResetUserPasswordMutationVariables
  > = (props) => {
    const { clinicId, userId } = props ?? {}

    return resetUserPassword(clinicId, userId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPassword>>>

export type ResetUserPasswordMutationError = ErrorType<ApiError>
export type ResetUserPasswordMutationVariables = { clinicId: string; userId: string }

/**
 * @summary A new temporary password, shown once (C-13 Reset password → C-13b)
 */
export const useResetUserPassword = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetUserPassword>>,
      TError,
      ResetUserPasswordMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resetUserPassword>>,
  TError,
  ResetUserPasswordMutationVariables,
  TContext
> => {
  return useMutation(getResetUserPasswordMutationOptions(options), queryClient)
}

export const getEndClinicImpersonationUrl = () => {
  return `/v1/clinic/impersonation/end`
}

/**
 * @summary End the impersonation in X-Impersonation-Id from the clinic app (banner Exit, sign-out); idempotent
 */
export const endClinicImpersonation = async (
  endImpersonationRequest?: EndImpersonationRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<void>(getEndClinicImpersonationUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(endImpersonationRequest),
  })
}

export const getEndClinicImpersonationMutationKey = () => ['endClinicImpersonation'] as const

export const getEndClinicImpersonationMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endClinicImpersonation>>,
    TError,
    EndClinicImpersonationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof endClinicImpersonation>>,
  TError,
  EndClinicImpersonationMutationVariables,
  TContext
> => {
  const mutationKey = getEndClinicImpersonationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endClinicImpersonation>>,
    EndClinicImpersonationMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return endClinicImpersonation(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type EndClinicImpersonationMutationResult = NonNullable<Awaited<ReturnType<typeof endClinicImpersonation>>>
export type EndClinicImpersonationMutationBody = BodyType<EndImpersonationRequest> | undefined
export type EndClinicImpersonationMutationError = ErrorType<ApiError>
export type EndClinicImpersonationMutationVariables = { data?: BodyType<EndImpersonationRequest> }

/**
 * @summary End the impersonation in X-Impersonation-Id from the clinic app (banner Exit, sign-out); idempotent
 */
export const useEndClinicImpersonation = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof endClinicImpersonation>>,
      TError,
      EndClinicImpersonationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof endClinicImpersonation>>,
  TError,
  EndClinicImpersonationMutationVariables,
  TContext
> => {
  return useMutation(getEndClinicImpersonationMutationOptions(options), queryClient)
}
